<template>
    <v-app v-if="finished_preloading">
      <ModalLoader />
      <LoadingSpinner />
      <Snackbar />
      <Toolbar />
  
      <v-content class="subPrimary">
        <v-container fluid class="page-container subPrimary">
          <v-container fluid>
            <!-- HEADER -->
            <Header :skin="skin">
              <!-- ICON -->
              <template #icon>
                <slot name="icon"></slot>
              </template>
  
              <!-- TITLE -->
              <template #title>
                <slot name="title"></slot>
              </template>
            </Header>
  
            <!-- BODY -->
            <v-flex align-end justify-space-between row fill-height>
              <slot name="body"></slot>
            </v-flex>
          </v-container>
        </v-container>
  
        <!-- FOOTER -->
        <FooterDesktop v-if="!$isPhoneDevice" :skin="skin" />
        <FooterMobile v-if="$isPhoneDevice" :skin="skin" />
      </v-content>
    </v-app>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    // Most common used layout
    name: "DefaultLayout",
    components: {
      Header: () => import("./Header.desktop"),
      FooterMobile: () => import("./Footer.mobile.vue"),
      FooterDesktop: () => import("./Footer.desktop.vue"),
      Toolbar: () => import("@/components/App/Toolbar"),
      Snackbar: () => import("@/components/App/Snackbar"),
      LoadingSpinner: () => import("@/components/App/LoadingSpinner"),
    },
    data: () => ({
      showCompatibilityAlert: true,
      version: process.env.VUE_APP_VERSION,
      finished_preloading: false
    }),
    watch: {
      showCompatibilityAlert(val) {
        if (!val) {
          this.closeAlert();
        }
      }
    },
    computed: {
      ...mapState({
        settings: state => state.settings,
        skin: state => state.settings.skin,
        categories: state => state.catalog.categories
      }),
      displayMessage() {
        return this.settings.ieVersion > -1 & this.settings.ieVersion < 12 & this.settings.displayCompatibilityMessage;
      }
    },
    methods: {
      ...mapActions({
        SET_DISPLAY_COMPATIBILITY_MESSAGE: "settings/SET_DISPLAY_COMPATIBILITY_MESSAGE",
        GET_CATEGORIES_TREE: "catalog/GET_CATEGORIES_TREE",
        GET_SKIN: 'settings/GET_SKIN'
      }),
      closeAlert() {
        this.SET_DISPLAY_COMPATIBILITY_MESSAGE(false);
      }
    },
    async mounted() {
      await this.GET_SKIN();
  
      const theme = {
        primary: { base: this.skin.primary_color },
        secondary: { base: this.skin.secondary_color },
        white: {
          base: '#FFFFFF'
        },
        subPrimary: {
          base: '#EFF2F5'
        },
        base: {
          base: '#025064'
        },
        accent: {
          base: '#ff2102',
        },
        tertiary: {
          base: '#3CA7DC',
        },
        blue: {
          base: '#e4df81',
        },
        jade: {
          base: '#049e8a',
        },
        orange: {
          base: '#7BAFC4',
        },
        aqua: {
          base: '#90D2B5',
        },
        green: {
          base: '#A3D183',
        },
        lightGray: {
          base: '#C4C6C7',
        },
        offWhite: {
          base: '#F0EDE0',
        },
        error: {
          base: '#FF5252',
        },
        info: {
          base: '#2196F3',
        },
        success: {
          base: '#4CAF50',
        },
        warning: {
          base: '#FFC107',
        },
        dataTable: {
          base: '#999',
        }
      }
  
      this.$vuetify.theme = { ...this.$vuetify.theme, ...theme  }
  
      await this.GET_CATEGORIES_TREE()
      this.finished_preloading = true;
    }
  };
  </script>
  
  <style lang="stylus">
    .sugestion-alert
      opacity:0.9;
      position:fixed;
      bottom:0;
      width:100%;
      left:0;
      z-index:10
    .page-container
      padding-bottom 70px
    .location
      margin-left: 100px;
    .box {
      display: flex
      align-items: center
    }
  
  </style>
  